import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=ff58f414&scoped=true&"
import script from "./TaskDetail.vue?vue&type=script&lang=js&"
export * from "./TaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=ff58f414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff58f414",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff58f414')) {
      api.createRecord('ff58f414', component.options)
    } else {
      api.reload('ff58f414', component.options)
    }
    module.hot.accept("./TaskDetail.vue?vue&type=template&id=ff58f414&scoped=true&", function () {
      api.rerender('ff58f414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/task/TaskDetail.vue"
export default component.exports